import { Component, OnInit, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { localDataService } from '../../Services/localDataServices';


declare var $: any;  //定义jquery
declare var async: any;  //定义jquery
@Component({
  selector: 'img-pl',
  providers: [localDataService],
  templateUrl: './imageBatchComponent.html',
})


export class imageBatchComponent implements OnInit {

  status: any;
  set: any = {
    shipper: { value: null },
    consignee: { value: null },
    notifyParty: { value: null },
    boxType: { value: null },
    boxVolume: { value: null },
    portOfLoading: { value: null },
    portOfDischarge: { value: null },
    transitPort: { value: null },
    placeOfDelivery: { value: null },
    goodName: { value: null },

    packing: { value: null },
    etd: { value: null },
    shipName: { value: null },
    volume: { value: null },
    numberOfPieces: { value: null },
    grossWeight: { value: null },
    vessel: { value: null },
    voyage: { value: null },
    paymenTerm: { value: null },
    serviceTerm: { value: null },

    deliveryTerm: { value: null },
    goodSize: { value: null },
    orderType: { value: null },
    fclOrLcl: { value: null },
    contacts: { value: null },
    remarks: { value: null },
    marks: { value: null }
  };
  userJson: any = {
    shipper: null,
    consignee: null,
    notifyParty: null,
    boxType: null,
    boxVolume: null,
    portOfLoading: null,
    portOfDischarge: null,
    transitPort: null,
    placeOfDelivery: null,
    goodName: null,

    packing: null,
    etd: null,
    shipName: null,
    volume: null,
    numberOfPieces: null,
    grossWeight: null,
    vessel: null,
    voyage: null,
    paymenTerm: null,
    serviceTerm: null,

    deliveryTerm: null,
    goodSize: null,
    orderType: null,
    fclOrLcl: null,
    contacts: null,
    remarks: null,
    marks: null
  };
  imgUrl: string;
  scoreUrl: string;
  _id: any;
  n: number;
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _localDataService: localDataService,
    private _location: Location,
  ) { }

  ngOnInit() {
    //$('[mag-thumb="inner"]').mag();
    let pthis = this;
    this.n = 0;
    var a = setInterval(function () {
      if (pthis.n > 180) {
        clearInterval(a);
        return false;
      }
      pthis._localDataService.tuoshu(pthis._activatedRoute.snapshot.url[1].path)
        .then(data => {
          pthis.status = data;
          pthis.n++;
          if (pthis.status.data.attrJson) {
            clearInterval(a);
            pthis.getdata(pthis._activatedRoute.snapshot.url[1].path)
          } else {
            $(".djs").show()
          }
        }).catch(err => { console.log(err); });
    }, 1000)

  }

  pcmessage: string;
  zxd: any;
  getdata(orderNo) {
    $(".djs").hide()
    this._localDataService.tuoshu(orderNo)
      .then(data => {
        this.status = data;
        if (this.status.status) {

          this.set = this.status.data.attrJson;
          let arr = ['shipper', 'consignee', 'notifyParty', 'boxType', 'boxVolume', 'portOfLoading', 'portOfDischarge', 'transitPort', 'placeOfDelivery', 'goodName',
            'packing', 'etd', 'shipName', 'volume', 'numberOfPieces', 'grossWeight', 'vessel', 'voyage', 'paymenTerm', 'serviceTerm',
            'deliveryTerm', 'goodSize', 'orderType', 'fclOrLcl', 'contacts', 'remarks', 'marks']
          for (let i = 0; i < arr.length; i++) {
            this.set[arr[i]] ? this.set[arr[i]] = this.set[arr[i]] : this.set[arr[i]] = { value: null }
          }
          this._id = this.status.data._id
          this.imgUrl = this.status.data.attrJson.imgPath;
          this.scoreUrl = this.status.data.attrJson.originalPath;
          this.zxd = ((1 - (this.status.data.fileList[0].suspiciousWords / this.status.data.fileList[0].totalWords)) * 100) || 100
          if (this.scoreUrl.indexOf("pdf") > -1) {
            $(".iframeScore").attr("src", this.scoreUrl)
          } else if (("png/jpg/gif").indexOf(this.scoreUrl.substring(this.scoreUrl.length - 2, this.scoreUrl.length - 1)) > -1) {
            console.log(this.scoreUrl.substring(this.scoreUrl.length - 3, this.scoreUrl.length))
            $(".iframeScore").attr("src", this.imgUrl)
          } else {
            $(".iframeScore").attr("src", "https://view.officeapps.live.com/op/view.aspx?src=" + this.scoreUrl)
          }



          // var imgurl = this.status.data.fileList[0].ocrOssKey;
          // var strHTML = '';
          // imgurl = '/ossxmlfile/' + imgurl;
          // $.ajax({
          //   type: "GET",
          //   url: imgurl,
          //   dataType: "xml",
          //   success: function (data) {
          //     console.log($(data))
          //     var xmlHeight = $(data)[0].all[0].attributes[1].nodeValue;
          //     var xmlwidth = $(data)[0].all[0].attributes[0].nodeValue;
          //     let bili = xmlwidth / $(".tibcontant").css("width").split('px')[0];
          //     strHTML += '<div class="xml" style="position:relative;width:100%;height:' + xmlHeight / bili + 'px;width:' + xmlwidth / bili + 'px;border:1px solid #ccc">'
          //     $(data).find("line").each(function (i) {

          //       var l = $(this).attr('l') / bili;
          //       var t = $(this).attr('t') / bili;
          //       var text = $(this).find("formatting").text();
          //       strHTML += "<div style='position: absolute;left:" + l + "px;top:" + t + "px;font-size:12px'>" + text + "</div>"
          //     });
          //     strHTML += '</div>'
          //     $("#xmlshow").css("height", xmlHeight / bili + 'px')
          //     $("#xmlshow").html(strHTML)
          //   }
          // });

        } else {

        }

      }).catch(err => { console.log(err); });
  }


  updata() {
    let pthis = this;
    Object.keys(this.set).forEach(function (key) {
      pthis.userJson[key] = pthis.set[key].value;
      console.log(pthis.userJson);
    });
    this._localDataService.tuoshuUpdata(this.userJson, this._id, this.set)
      .then(data => {
        this.status = data;
        if (this.status.status) {
          alert("保存成功!")
        } else {
          alert(this.status.message)
        }

      }).catch(err => { console.log(err); });
  }

  changeTab(i) {
    $(".tib").css("background", "#fff").eq(i).css("background", "#eee")
    $(".tibcontant").css("display", "none").eq(i).css("display", "block")
  }

  closepcmsg() {
    $(".hullabaloo").fadeOut()
  }

  rows: any;
  zuobiao(rows) {
    this.rows = rows;
    $(".SDcanvas").remove()
    let imgwidth = $('.tuoshuimg').find('img').css("width").split("px")[0];
    let str = "<div class='SDcanvas' style='position:absolute;width:" + Number(rows.right - rows.left) * Number(imgwidth / this.set.width) + "px;height:" + Number(rows.bottom - rows.top) * Number(imgwidth / this.set.width) + "px;border:2px solid red;top:" + Number(rows.top) * Number(imgwidth / this.set.width) + "px;left:" + Number(rows.left) * Number(imgwidth / this.set.width) + "px'></div></div>"
    $('.tuoshuimg').append(str)
  }

  wwwidth(type, event) {
    let obj = $(event.target).parent().find('img');
    let SDcanvas = $(event.target).parent().find('.SDcanvas');

    let ww = Number(obj.width())
    if (type == 1) {
      ww = ww + 80
    } else {
      ww = ww - 80
    }

    obj.css("width", ww + "px")

    let parsentImgWidth = obj.css("width").split("px")[0];
    //修改数组里面的比例；
    SDcanvas.css({ "width": Number(this.rows.right - this.rows.left) * Number(parsentImgWidth / this.set.width) + "px", "height": Number(this.rows.bottom - this.rows.top) * Number(parsentImgWidth / this.set.width) + "px", "top": Number(this.rows.top) * Number(parsentImgWidth / this.set.width) + "px", "left": Number(this.rows.left) * Number(parsentImgWidth / this.set.width) + "px" })
  }


}



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/component/imageBatch/imageBatchComponent.ts